export { ClassicPrispevkyProps } from './classic/classic-prispevky.props';
export { ImagePrispevkyProps } from './image/image-prispevky.props';
export const name_image = "ImagePrispevkyComponent";
export const name_classic = "ClassicPrispevkyComponent";
